// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3sqbJ","buttons":"RemoveExpirationActionButtons_buttons__3kk_2"};